import { useMutation, useQueryClient } from "react-query";
import { addMenu, deleteMenu, editMenu } from "../../../services/inventory";

export const useCreateStorefront = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["createStorefront"],
    mutationFn: (data) => addMenu(data),
    onSuccess: () => {
      queryClient.invalidateQueries(["getMenuProducts"]);
      queryClient.invalidateQueries(["getStorefrontList"]);
    },
  });
};

export const useUpdateStorefront = ({ id }) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["updateStorefront"],
    mutationFn: (data) => editMenu(data),
    onSuccess: () => {
      queryClient.invalidateQueries(["getMenuProducts"]);
      queryClient.invalidateQueries(["getStorefrontList"]);
      queryClient.invalidateQueries(["getSelectedStorefrontProduct", id]);
    },
  });
};

export const useDeleteStorefront = ({ id }) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["deleteMenu"],
    mutationFn: () => deleteMenu(id),
    onSuccess: () => {
      queryClient.invalidateQueries(["getStorefrontList"]);
    },
  });
};
